<ng-progress style="direction: ltr;" [spinner]="false" [direction]="exdrLanguageService.currentLanguage?.isRtl ? 'rtl+' : 'ltr+'" 
(started)="onLoadingStart()" (completed)="onLoadingEnd()" ngProgressHttp></ng-progress>
<div [dir]="exdrLanguageService.currentLanguage?.isRtl ? 'rtl' : 'ltr'">
  <div class="main-spinner" *ngIf="showSpinner">
    <mat-spinner></mat-spinner>
  </div>
  <router-outlet></router-outlet>
</div>
